<template>
	<div class="side-nav-layout">
		<SideNav
			:current-user="currentUser"
			:store="store"
			:user-projects="userProjects"
			:current-project="currentProject"
			:is-user-logged-in="isUserLoggedIn"
		/>
		<main class="layout-content" :class="{ 'layout-content--overlay-nav': overlayNav }">
			<slot />
		</main>
	</div>
</template>

<script setup lang="ts">
import { inject } from "vue"
import { storeToRefs } from "pinia"
import { UseRootStore } from "@/model/RootStore"
import { ProjectStoreKey } from "@/stores/projectStore"
import SideNav from "@/components/layout/SideNav.vue"

defineProps<{
	// SideNav already floats over the page (position: fixed); when true, content stays full-width
	// and never reflows as the rail collapses/expands, instead of being pushed to clear it.
	overlayNav?: boolean
}>()

const store = UseRootStore()
const { currentUser, isUserLoggedIn, userProjects } = storeToRefs(store)

const projectStore = inject(ProjectStoreKey)!()
const { currentProject } = storeToRefs(projectStore)
</script>

<style scoped>
.side-nav-layout {
	display: flex;
	height: 100vh;
	width: 100%;
}

.layout-content {
	position: fixed;
	left: var(--width-nav-expanded);
	right: 0;
	top: 0;
	bottom: 0;
	overflow-y: auto;
	transition: left 0.3s ease;
}

.side-nav-layout:has(.app-sidebar.side-nav.collapsed) .layout-content {
	left: var(--width-nav-collapsed);
}

.side-nav-layout:has(.app-sidebar.side-nav):not(:has(.app-sidebar.collapsed)) .layout-content {
	left: var(--width-nav-side);
}

.side-nav-layout:has(.mobile-nav) .layout-content {
	bottom: calc(var(--space-56) + env(safe-area-inset-bottom));
}

.layout-content--overlay-nav {
	left: 0 !important;
	transition: none;
}

@media (max-width: 768px) {
	.layout-content {
		left: 0;
	}
}
</style>
